export const globalAntTheme = {
  token: {},
  components: {
    Input: {
      hoverBorderColor: '#CAC9CC',
      activeBorderColor: '#CAC9CC',
      activeShadow: '#CAC9CC',
      errorActiveShadow:  '#CAC9CC',
    },
    Button: {
      defaultHoverColor: '#5A1EDB',
      groupBorderColor: '#CAC9CC',
      defaultHoverBorderColor: '#CAC9CC',
      defaultActiveBorderColor: '#CAC9CC',
      defaultActiveColor: '#CAC9CC',
      borderColorDisabled: 'rgba(151, 151, 153, 1)'
    },
    Select: {
      activeBorderColor: 'rgba(202, 201, 204, 1)',
      activeOutlineColor: 'rgba(255, 255, 255, 0)',
      hoverBorderColor: 'rgba(202, 201, 204, 1)',
      multipleItemBorderColor: 'rgba(202, 201, 204, 1)'
    }
  },
};
